import CircleLoader from '@components/CircleLoader'

const DeleteButton = ({ onClick, pending }) =>
    pending ? (
        <CircleLoader className="ml-2" size="small" />
    ) : (
        <button className="delete toggleVisible" onClick={onClick} />
    )

export default DeleteButton
